import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const FacebookVideoTestimonials = () => {
  const videoTestimonials = [
    {
      id: 1,
      embedUrl: 'https://www.youtube.com/embed/cDZYuJi4pVU',
      title: 'Global Testimonial Video 1',
      type: 'youtube'
    },
    {
      id: 2,
      embedUrl: 'https://www.youtube.com/embed/EBeImozy9zQ',
      title: 'Global Testimonial Video 2',
      type: 'youtube'
    },
    {
      id: 3,
      embedUrl: 'https://www.youtube.com/embed/5lgzwEJcexM',
      title: 'Global Testimonial Video 3',
      type: 'youtube'
    },
    {
      id: 4,
      embedUrl: 'https://www.youtube.com/embed/xe1JVKKocu0',
      title: 'Global Testimonial Video 4',
      type: 'youtube'
    },
    {
      id: 5,
      embedUrl: 'https://www.youtube.com/embed/KNEdbLAIMkU',
      title: 'Global Testimonial Video 5',
      type: 'youtube'
    },
    {
      id: 6,
      embedUrl: 'https://www.youtube.com/embed/A-_Qli5Ohp8',
      title: 'Global Testimonial Video 6',
      type: 'youtube'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 px-4 md:px-6 lg:px-8 bg-gradient-to-b from-card to-background">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-10 md:mb-14 lg:mb-16"
        >
          <motion.div
            className="inline-flex items-center gap-2 px-4 py-2 md:px-5 md:py-2.5 rounded-full bg-accent/10 border border-accent/20 mb-4 md:mb-6"
            whileHover={{ scale: 1.05 }}
          >
            <Icon name="Video" size={16} color="var(--color-accent)" />
            <span className="text-xs md:text-sm lg:text-base font-medium text-accent">
              Video Testimonials
            </span>
          </motion.div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-5 lg:mb-6">
            <span className="bg-gradient-to-r from-accent via-primary to-secondary bg-clip-text text-transparent">
              Global Testimonials
            </span>
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Hear what people from all over the world have to say about Edrian
          </p>
        </motion.div>

        {/* Video Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-10">
          {videoTestimonials?.map((video, index) => (
            <motion.div
              key={video?.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-card rounded-xl border border-border overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  src={video?.embedUrl}
                  className="absolute top-0 left-0 w-full h-full"
                  style={{ border: 'none', overflow: 'hidden' }}
                  scrolling="no"
                  frameBorder="0"
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  title={video?.title}
                />
              </div>
            </motion.div>
          ))}
        </div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-10 md:mt-12 lg:mt-16"
        >
          <p className="text-base md:text-lg text-muted-foreground mb-4">
            Want to share your experience working with Edrian?
          </p>
          <motion.a
            href="/contact-hub"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-colors"
          >
            <Icon name="MessageCircle" size={20} color="currentColor" />
            Get in Touch
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default FacebookVideoTestimonials;